<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>
                    {{ walletVdr }}
                  </td>
                  <td>
                    <span class="label badge-danger" v-if="getErrorWalletSeller || getErrorWalletSellerStatus"><i class="fa fa-times"></i> {{ sellerMessageStatus }} </span>
                    <span class="label label-primary" v-else><i class="fa fa-check"></i> {{ sellerMessageStatus }} </span>
                  </td>
                  <td v-if="getErrorDocumentSeller" class="btn-document">
                    <router-link :to="{ name: 'command-details-documents' }">
                      <button type="button" class="btn btn-w-m btn-default"><i class="fa fa-files-o"></i> Documents</button>
                    </router-link>
                  </td>
                  <td v-if="getErrorWalletSeller || getErrorWalletSellerStatus">
                    <span class="m-xs errorWallet"> {{ getErrorWalletSeller }} </span>
                    <span v-if="getErrorWalletSellerStatus" class="m-xs errorWallet"> {{ getErrorWalletSellerStatus }} </span>
                  </td>
                </tr>
                <tr>

                  <td>
                    {{ walletAct }}
                  </td>
                  <td>
                    <span class="label badge-danger" v-if="getErrorWalletBuyer || getErrorWalletBuyerStatus"><i class="fa fa-times"></i> {{ buyerMessageStatus }} </span>
                    <span class="label label-primary" v-else><i class="fa fa-check"></i> {{ buyerMessageStatus }} </span>
                  </td>
                  <td v-if="getErrorWalletBuyer || getErrorWalletBuyerStatus">
                    <span class="m-xs errorWallet"> {{ getErrorWalletBuyer }} </span>
                    <span v-if="getErrorWalletBuyerStatus" class="m-xs errorWallet"> {{ getErrorWalletBuyerStatus }} </span>
                  </td>

                </tr>
                <tr>
                  <td>
                    Solde wallet Acheteur
                  </td>
                  <td>
                    <span class="label badge-danger" v-if="getErrorWBalanceBuyer"><i class="fa fa-times"></i> {{ getWalletBuyerAmount | formatDecimalPrice }} € </span>
                    <span class="label lemonway-btn" :class="warningWalletBuyer === false ? 'label-primary' : 'btn-warning'" v-else><i class="fa fa-check"></i> {{ getWalletBuyerAmount | formatDecimalPrice }} €</span>
                  </td>
                  <td v-if="getErrorWBalanceBuyer">
                    <span class="m-xs errorWallet"> {{ getErrorWBalanceBuyer }} </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-right">
        <button type="button" class="btn btn-w-m btn-primary" :class="this.btnValid === false ? 'disabled' : 'activated'" @click="onSubmit"><i class="fa fa-dollar"></i> Proceder au virements P2P </button> <br>
        <span v-if="getErrorStatus" class="m-xs errorWallet"> {{ getErrorStatus }} </span>
      </div>
    </div>
  </div>
</template>

<script>

import gql from "graphql-tag";
import WarrantyOptionList from "@/api/query/WarrantyOptionList.gql";

export default {
  props: {
    statuSaller: {
      type: [String, Number],
      default: ""
    },
    statuBuyer: {
      type: [String, Number],
      default: ""
    },
    walletAct: {
      type: String,
      default: ""
    },
    walletVdr: {
      type: String,
      default: ""
    },
    getTotalAmount: {
      type: [String, Number],
      default: ""
    },
    getNetVendeurAmount: {
      type: [String, Number],
      default: ""
    },
    getTotalAmountForCheque: {
      type: [String, Number],
      default: ""
    },
    getPaymentLabel: {
      type: String,
      default: ""
    },
    getWalletBuyerAmount: {
      type: [String, Number],
      default: ""
    },
    isvalidSeller:{
      type: [Boolean],
    },
    isvalidBuyer:{
      type: [Boolean],
    },
    getWalletSellerAmount:{
      type: [String, Number],
      default: ""
    },
    status: {
      type: [String, Number, Object],
      default: ""
    },
    sellerMessageStatus: {
      type: [String, Number, Object],
      default: ""
    },
    buyerMessageStatus: {
      type: [String, Number, Object],
      default: ""
    },
    orderId: {
      type: [String, Number],
      default: ""
    },
    idCustomerSeller: {
      type: [String, Number],
      default: ""
    },
    idCustomerBuyer: {
      type: [String, Number],
      default: ""
    }
  },
  data: () => ({
    walletControlInfo: {
      status: "",
    },
  }),
  computed: {
    warningWalletBuyer () {
      let walleterror = false
      if (this.getWalletBuyerAmount > this.getTotalAmount) walleterror = true
      return walleterror
    },
    btnValid () {
      let isValid

      if (
          this.statuBuyer === 0
          || this.statuSaller === 0
          || this.status.label !== "Cession finalisée"
          || this.getErrorWalletBuyerStatus !== ""
          || this.getErrorWalletSellerStatus !== ""
      ) {
        if (this.getPaymentLabel === "Chèque de banque") {
          if (this.getWalletBuyerAmount < this.getTotalAmountForCheque) isValid = false
        } else if (this.getWalletBuyerAmount < this.getTotalAmount) isValid = false
      } else isValid = true
      return isValid
    },
    getErrorWalletBuyerStatus () {
      let errorWalletBuyerSatus = ""
      if (this.statuBuyer !== 0) {
        if (this.statuBuyer !== 5 && this.statuBuyer !== 6 && this.statuBuyer !== 16) errorWalletBuyerSatus = "Statut du wallet doit être à KYC 1, KYC 2 ou Client occasionnel"
      }
      return errorWalletBuyerSatus
    },
    getErrorWalletSellerStatus () {
      let errorWalletBuyerSatus = ""
      if (this.statuSaller !== 0) {
        if (this.getPaymentLabel === "Chèque de banque") {
          if (this.statuSaller === 10) errorWalletBuyerSatus = "Wallet status Bloqué"
        } else {
          if (this.statuSaller !== 6) errorWalletBuyerSatus = "Statut du wallet doit être à KYC 2"
        }
      }
      return errorWalletBuyerSatus
    },
    getErrorWalletBuyer () {
      let errorWalletBuyer = ""
      if (this.statuBuyer === 0) errorWalletBuyer = "Aucun wallet trouvé"
      return errorWalletBuyer
    },
    getErrorWBalanceBuyer () {
      let errorWalletBuyer = ""
      if (this.statuBuyer === 0) {
        errorWalletBuyer = "Aucun wallet trouvé"
      } else {
        if (this.getPaymentLabel === "Chèque de banque") {
          if (this.getWalletBuyerAmount < this.getTotalAmountForCheque) errorWalletBuyer = "Le solde du wallet acheteur est inférieur à la commande"
        }else if (this.getWalletBuyerAmount < this.getTotalAmount) errorWalletBuyer = "Le solde du wallet acheteur est inférieur à la commande"
      }
      return errorWalletBuyer
    },
    getErrorWalletSeller () {
      let errorWalletSeller = ""
      if (this.statuSaller === 0) errorWalletSeller = "Aucun wallet trouvé"
      return errorWalletSeller
    },
    getErrorStatus () {
      let errorstatus = ""
      if (this.status.label !== "Cession finalisée" && this.status.label !== "virements P2P effectués" && this.status.label !== "virements externe effectués") errorstatus = "La cession de la commande n'est pas finalisée"
      return errorstatus
    },
    getErrorDocumentSeller () {
      let errorDocumentSeller = false
      if (this.statuSaller !== 0) if (this.statuSaller !== 6 ) errorDocumentSeller = true
      return errorDocumentSeller
    },
    setWalletControlMutation () {
      return gql`
          mutation {
            setWalletControl(orderId: ${this.orderId})
            {
              status
            }
          }`
    },
  },
  async created () {
    await this.getWalletControlQuery()
    if (this.walletControlInfo.status === true) this.$parent.toggleBlock(2)
  },
  methods: {
    getCustomerEditUrl (id) {
      return process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_CUSTOMER_EDIT + id
    },
    async getWalletControlQuery () {
      const WalletControlInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getWalletControl (orderId: ${this.orderId}) {
                        status
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.walletControlInfo.status = WalletControlInfo.data.getWalletControl.status

    },
    async onSubmit () {
      let result = await this.btnValid
      if (result === true) {
        this.$apollo.mutate({
          mutation: this.setWalletControlMutation
        }).then(() => {
          this.showBanner('success', `Succès: le virement p2p terminé`)
          this.$parent.toggleBlock(2)
        })
      }else {
        return
      }

    },
  },
  apollo: {
  }
}
</script>
